import React from 'react';
import { FormattedMessage } from 'react-intl';

// styles
import styles from './styles/ShopVerticals.scss';

export const verticalsConfig = [
    {
        ctaUrl: '/furniture/',
        imageSrc:
            'https://internal.1stdibscdn.com/cms/generic/CMS_GENERIC_IMAGE/1548216339_2i2pn/Furniture.jpg',
        title: (
            <FormattedMessage id="discover.shopVerticals.furniture" defaultMessage="Furniture" />
        ),
    },
    {
        ctaUrl: '/art/',
        imageSrc:
            'https://internal.1stdibscdn.com/cms/generic/CMS_GENERIC_IMAGE/1548216580_gn6e7/Art.jpg',
        title: <FormattedMessage id="discover.shopVerticals.art" defaultMessage="Art" />,
    },
    {
        ctaUrl: '/jewelry/',
        imageSrc:
            'https://internal.1stdibscdn.com/cms/generic/CMS_GENERIC_IMAGE/1548215929_q3e3a/Jewelry.jpg',
        title: <FormattedMessage id="discover.shopVerticals.jewelry" defaultMessage="Jewelry" />,
    },
    {
        ctaUrl: '/fashion/',
        imageSrc:
            'https://internal.1stdibscdn.com/cms/generic/CMS_GENERIC_IMAGE/1548216519_t560s/Fashion.jpg',
        title: <FormattedMessage id="discover.shopVerticals.fashion" defaultMessage="Fashion" />,
    },
];

export const ShopVerticals = () => {
    return (
        <div className={`rowFlex ${styles.container}`}>
            {verticalsConfig.map(({ imageSrc, ctaUrl, title }) => (
                <div className={`colXs3 ${styles.vertical}`} key={ctaUrl}>
                    <div className={styles.boxWrapper}>
                        <img src={imageSrc} className={styles.image} />
                        <div className={styles.box}>
                            <div className={styles.title}>{title}</div>
                            <a href={ctaUrl} className={styles.cta}>
                                <FormattedMessage
                                    id="discover.shopVerticals.shop"
                                    defaultMessage="Shop"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
